import { TFunction } from 'next-i18next'

import { BookingCurrency } from '~/types/booking'
import { formatThousands } from '~/utils'
import { getPrefix } from '~/booking/utils/booking.utils'

import { HighlightChat, HighlightVideoChat, HighlightPrivateTutor } from './TutorOnDemandProductCards.constants'

export function i18nifyHighlights(t: TFunction, type: 'chat' | 'video-chat' | 'tutoring'): string[] {
  const path = 'tutorOnDemand:landingPage.productCard'

  switch (type) {
    case 'chat':
      return Object.values(HighlightChat).map((elem) => t(`${path}.chat.${elem}`))

    case 'video-chat':
      return Object.values(HighlightVideoChat).map((elem) => t(`${path}.videoChat.${elem}`))

    case 'tutoring':
      return Object.values(HighlightPrivateTutor).map((elem) => t(`${path}.privateTutor.${elem}`))

    default:
      throw new Error(`No such type: ${type}.`)
  }
}

export function getPriceWithCurrency(currency: BookingCurrency, price: number): string {
  const currencyPrefix = getPrefix(currency)
  const formattedPrice = formatThousands(price)
  return `${currencyPrefix} ${formattedPrice}`
}
